module.exports = __webpack_public_path__ + "img/linkedin.61cd95c7.svg";